import { AnnotationToolEnum, ImageType } from '@dermloop/static-values';
import {
  ArrayNotEmpty,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Min,
} from 'class-validator';
import { NamedEntityDto } from '../clinical-details';
import { DiagnosisDto } from './diagnosis.dto';

export interface ImageCriteriaDto extends NamedEntityDto {
  altName?: string;
  diagnoses?: DiagnosisDto[];
  imageType: ImageType;
  defaultAnnotationTool?: AnnotationToolEnum;
}

export interface ImageCriteriaSearchResultDto extends NamedEntityDto {
  altName?: string;
}

export class ImageCriteriaSearchQueryDto {
  @IsNumber()
  @Min(0)
  skip: number;

  @IsNumber()
  @Min(1)
  take: number;

  @IsOptional()
  @IsString()
  searchText?: string;
}

export class CreateImageCriteriaDto implements Partial<ImageCriteriaDto> {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsUUID()
  @IsNotEmpty()
  imageTypeId: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsOptional()
  @IsString()
  altName?: string;

  @IsOptional()
  @IsEnum(AnnotationToolEnum)
  defaultAnnotationTool?: AnnotationToolEnum;
}

export class UpdateImageCriteriaDto implements Partial<ImageCriteriaDto> {
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  name?: string;

  @IsOptional()
  @IsUUID()
  @IsNotEmpty()
  imageTypeId?: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsOptional()
  @IsString()
  altName?: string;

  @IsOptional()
  @IsEnum(AnnotationToolEnum)
  defaultAnnotationTool?: AnnotationToolEnum;
}

/**
 * DTO for adding diagnoses to an image criteria.
 */
export class AddDiagnosisToImageCriteriaDto {
  @ArrayNotEmpty()
  @IsUUID('all', { each: true })
  diagnosisIds: string[];
}
